export default __webpack_public_path__ + "static/media/appointment img1.73de9a63.webp";